var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBoardBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9805 9.85879L27.0659 29.5901C26.7159 31.063 25.4034 32.0838 23.8868 32.0838H4.72425C2.52217 32.0838 0.947193 29.9254 1.60344 27.8108L7.74301 8.09427C8.16593 6.72344 9.4347 5.77539 10.8639 5.77539H28.8014C30.1868 5.77539 31.3389 6.62123 31.8201 7.7879C32.0972 8.41498 32.1555 9.12963 31.9805 9.85879Z",
    stroke: "#20DACD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.332 32.0833H30.3029C32.1841 32.0833 33.657 30.4937 33.5258 28.6125L32.082 8.75",
    stroke: "#20DACD",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1172 9.30383L15.6339 3.00391",
    stroke: "#CB1C68",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8867 9.31935L25.2576 2.99023",
    stroke: "#CB1C68",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2305 17.5H22.8971",
    stroke: "#CB1C68",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76953 23.334H21.4362",
    stroke: "#CB1C68",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBoardBlue);
export default __webpack_public_path__ + "static/media/menu_board_blue.03898bd740ee0c6eb1db05fdbcaee1f4.svg";
export { ForwardRef as ReactComponent };